import React from "react";

const PageContainer = ({ children }) => {
  return <div className="profile-view-page-container clearfix">{children}</div>;
};

export default PageContainer;
